import { Row, Stack } from "react-bootstrap";
import PublicTransportBoundariesToggle from "./PublicTransportBoundariesToggle";
import ThemeToggle from "./ThemeToggle";

interface SwitchStackProps {
  ptLayerEnabled: boolean;
}

const SwitchStack = ({ ptLayerEnabled }: SwitchStackProps) => {
  return (
    <Stack className={!ptLayerEnabled ? "justify-content-center" : ""}>
      <Row>
        <ThemeToggle />
      </Row>

      <Row>{ptLayerEnabled && <PublicTransportBoundariesToggle />}</Row>
    </Stack>
  );
};

export default SwitchStack;
